module.exports = __webpack_public_path__ + "static/media/shiftChangeArrow.ae767c7e.svg";